import PayrollService from "../../services/PayrollService";
import { INPUT_VIEW_DIRECTION ,INPUT_TYPE} from "deskera-ui-library";
import i18next from "i18next";
import { LOCATION_NAME_REGEX } from "../../constants/RegexConstants";
export let empList = []

class AttendanceSettingService {
    static getUsers() {
        PayrollService.getUsersList().then((res: any) => {
            if (res && res.users) {
                empList = res.users;
            }
        });
    }

}
export default AttendanceSettingService;

export const NEW_GEO_LOCATION = [
    {
        key:"applicableToAll",
        columnCode: "applicableToAll",
        options:[{id:true,name:"Yes"},{id:false,name:"No"}],
        icon:"",
        validation:null,
        isValid:true,
        name:"Applicable to all employee",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"user",
        columnCode: "user",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Employee",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        multiSelect:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"name",
        columnCode: "name",
        options:[],
        icon:"",
        validation:{
            regExp: LOCATION_NAME_REGEX
        },
        isValid:true,
        name:"Location Name",
        type:INPUT_TYPE.TEXT,
        errorMessage: i18next.t("LOCATION_NAME_VALID_MSG"),
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"latLng",
        columnCode: "latLng",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Select Location",
        type:'button',
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"address",
        columnCode: "address",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Address",
        type:INPUT_TYPE.TEXT,
        errorMessage:"Select a valid address from Map",
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"latitude",
        columnCode: "latitude",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Latitude",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"longitude",
        columnCode: "longitude",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Longitude",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"radius",
        columnCode: "radius",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Radius (In Meters)",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        tooltip:i18next.t("RADIUS_SUGGESTION")
    },
    {
        key:"location",
        columnCode: "location",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Location",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        multiSelect:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"active",
        columnCode: "active",
        options:[{id:true,name:"Active"},{id:false,name:"Inactive"}],
        icon:"",
        validation:null,
        isValid:true,
        name:"Status",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    }
]
export const GEO_LOCATION_MAPPING = [
    {
        key:"applicableToAll",
        columnCode: "applicableToAll",
        options:[{id:true,name:"Yes"},{id:false,name:"No"}],
        icon:"",
        validation:null,
        isValid:true,
        name:"Applicable to all employee",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"user",
        columnCode: "user",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Employee",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        multiSelect:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"locations",
        columnCode: "locations",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Location",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        multiSelect:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"active",
        columnCode: "active",
        options:[{id:true,name:"Active"},{id:false,name:"Inactive"}],
        icon:"",
        validation:null,
        isValid:true,
        name:"Status",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    }
]

export const GEO_LOCATION_CONSTANT = {
    isApplicableTOAll:{ id: true, name: "Yes" },
    active:{
        id: true,
        name: "Active"
    },
    defaultRadius:'50'
}